import { createSlice } from "@reduxjs/toolkit";




const LoginSlice=createSlice({
    name:"login",
    initialState:{
        loading:false,
        logindata:[],
        message:null,
        userID:null,
    },
    reducers:{
        loginLoader:(state,action)=>{
            // console.log("inside the login loader",state,action);
            state.loading=true;
            state.message = null; //
        },
        loginSuccess:(state,action)=>{
            // console.log('inside the loginsuccess',state,action);
            state.loading=false;
            state.logindata=action.payload;
            state.message = null; 
        },
        loginFailure:(state,action)=>{
            // console.log('inside the loginfailure',state,action);
            state.loading=false;    
            state.message=action.payload;
        },
        clearLoginError: (state) => {    
            state.message = null;
        },
        setUserID:(state,action)=>{
            // console.log('inside the loginsuccess',state,action);
            state.userID=action.payload;
            console.log("inside the action/payload: ", action.payload);
             
        },
        
    }
})


// console.log("loginslice ::",LoginSlice);
export const {loginLoader,loginSuccess,loginFailure,clearLoginError, setUserID} =LoginSlice.actions;
export default LoginSlice.reducer;